import React from 'react';

const Gallery = () => {
  return (
    <div className="p-10 text-white">
      <h2 className="text-3xl font-bold mb-4">Gallery</h2>
      {/* Gallery images and videos */}
    </div>
  );
};

export default Gallery;
